/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1BannerMutationRequest,
  PostApiV1BannerMutationResponse,
  PostApiV1Banner400,
  PostApiV1Banner401,
  PostApiV1Banner404,
  PostApiV1Banner500,
} from "../../types/bannerRegistroController/PostApiV1Banner.ts";
import { buildFormData } from "../../.kubb/config.ts";

function getPostApiV1BannerUrl() {
  const res = { method: "POST", url: `/api/v1/banner` as const };
  return res;
}

/**
 * @description Cria um novo banner (multipart/form-data). A imagem é enviada no campo 'image' e vai para o storage. **(Requer Authorization para autenticação)**
 * @summary Criar banner (Requer Authorization para autenticação)
 * {@link /api/v1/banner}
 */
export async function postApiV1Banner(
  data?: PostApiV1BannerMutationRequest,
  config: Partial<RequestConfig<PostApiV1BannerMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;
  const formData = buildFormData(requestData);
  const res = await request<
    PostApiV1BannerMutationResponse,
    ResponseErrorConfig<
      | PostApiV1Banner400
      | PostApiV1Banner401
      | PostApiV1Banner404
      | PostApiV1Banner500
    >,
    PostApiV1BannerMutationRequest
  >({
    method: "POST",
    url: getPostApiV1BannerUrl().url.toString(),
    data: formData as FormData,
    ...requestConfig,
  });
  return res.data;
}
